import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/products-and-services/new/loading';

export const Route = createFileRoute('/_private/products-and-services/new')({
  pendingComponent: Loading,
});
